import { RotateClockwiseIcon } from '@repo/atomic-components';
import { HeaderIconButton } from '@/ui/pages/ChatPage/components/HeaderIconButton';

type ImagePreviewToolbarProps = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onRotateAnticlockwise: () => void;
  onRotateClockwise: () => void;
  canZoomIn: boolean;
  canZoomOut: boolean;
};

/** Floating bottom-right controls, styled like the PDF viewer's; shown on hover or while a button has keyboard focus. */
export function ImagePreviewToolbar({
  onZoomIn,
  onZoomOut,
  onRotateAnticlockwise,
  onRotateClockwise,
  canZoomIn,
  canZoomOut,
}: ImagePreviewToolbarProps) {
  return (
    <div
      role="toolbar"
      aria-label="Image controls"
      className="bg-theme-white/80 border-theme-border-grey/50 absolute right-3 bottom-3 z-50 flex items-center gap-1 rounded-[6px] border p-1 opacity-0 shadow-lg backdrop-blur-xl backdrop-saturate-[2] transition-opacity duration-200 group-hover:opacity-100 has-[:focus-visible]:opacity-100"
    >
      <HeaderIconButton
        icon={<i className="pi pi-search-plus text-[0.9375rem]" aria-hidden />}
        tooltip="Zoom in"
        tooltipPosition="top"
        disabled={!canZoomIn}
        onClick={onZoomIn}
      />
      <HeaderIconButton
        icon={<i className="pi pi-search-minus text-[0.9375rem]" aria-hidden />}
        tooltip="Zoom out"
        tooltipPosition="top"
        disabled={!canZoomOut}
        onClick={onZoomOut}
      />
      <HeaderIconButton
        icon={<RotateClockwiseIcon width={16} height={16} className="-scale-x-100" aria-hidden />}
        tooltip="Rotate 90° anti-clockwise"
        tooltipPosition="top"
        onClick={onRotateAnticlockwise}
      />
      <HeaderIconButton
        icon={<RotateClockwiseIcon width={16} height={16} aria-hidden />}
        tooltip="Rotate 90° clockwise"
        tooltipPosition="top"
        onClick={onRotateClockwise}
      />
    </div>
  );
}
